import { render, staticRenderFns } from "./DvTabs.vue?vue&type=template&id=1fca7cea&scoped=true&lang=pug"
import script from "./DvTabs.vue?vue&type=script&lang=js"
export * from "./DvTabs.vue?vue&type=script&lang=js"
import style0 from "./DvTabs.vue?vue&type=style&index=0&id=1fca7cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca7cea",
  null
  
)

export default component.exports